import { TMainPageLayoutV3 } from "../type";
import SocialMedia01 from "@/components/SocialMedia/components/SocialMedia01";


const MNPG068 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG068.rendered: ", props);
    
    return (
        <SocialMedia01 
            payload={props.template?.languageVersions}
            className="social-icon d-flex align-items-center"
        />
    )
}

export default MNPG068;
